/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type TopicScroll_scroll_Categories$ref = any;
export type TopicScrollContainer_allCategories_QueryVariables = {||};
export type TopicScrollContainer_allCategories_QueryResponse = {|
  +allCategories: ?{|
    +$fragmentRefs: TopicScroll_scroll_Categories$ref
  |}
|};
export type TopicScrollContainer_allCategories_Query = {|
  variables: TopicScrollContainer_allCategories_QueryVariables,
  response: TopicScrollContainer_allCategories_QueryResponse,
|};
*/


/*
query TopicScrollContainer_allCategories_Query {
  allCategories {
    ...TopicScroll_scroll_Categories
  }
}

fragment TopicScroll_scroll_Categories on CategoryNodeConnection {
  edges {
    node {
      id
      name
    }
  }
}
*/

const node/*: ConcreteRequest*/ = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TopicScrollContainer_allCategories_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CategoryNodeConnection",
        "kind": "LinkedField",
        "name": "allCategories",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TopicScroll_scroll_Categories"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TopicScrollContainer_allCategories_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CategoryNodeConnection",
        "kind": "LinkedField",
        "name": "allCategories",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CategoryNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CategoryNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "713568175610c22f7e5f42572a59918e",
    "id": null,
    "metadata": {},
    "name": "TopicScrollContainer_allCategories_Query",
    "operationKind": "query",
    "text": "query TopicScrollContainer_allCategories_Query {\n  allCategories {\n    ...TopicScroll_scroll_Categories\n  }\n}\n\nfragment TopicScroll_scroll_Categories on CategoryNodeConnection {\n  edges {\n    node {\n      id\n      name\n    }\n  }\n}\n"
  }
};
// prettier-ignore
(node/*: any*/).hash = '1a17b3fe0b8ea9cf8c8976a05beafb86';

module.exports = node;
